import * as React from 'react';
import * as autoBind from 'react-autobind';
import {ControlButton} from '@techsmith/tsc-cloud-style-guide';
import Themeable from '../../types/Themeable';
import Constants, {DashboardFilter, SortMetric} from '../../globals/Constants';
import ReviewService from '../../services/ReviewService/ReviewService';
import ErrorMessageModel from '../../types/ErrorMessageModel';
import AxiosCancelTokenHelper from '../../utils/AxiosCancelTokenHelper/AxiosCancelTokenHelper';
import Strings from '../../globals/Strings';
import ReviewModel from '../../types/ReviewModel';
import GoogleAnalyticsService from '../../services/GoogleAnalyticsService/GoogleAnalyticsService';
import Store from '../../redux/Store';

export default class LoadRemainingReviewsButton extends React.Component<LoadRemainingReviewsButtonProps, {}> {
   readonly state: LoadRemainingReviewsButtonState = {errorMessaging: null, isLoadingData: false};
   private loadReviewsCancelHelper: AxiosCancelTokenHelper;

   constructor(props: LoadRemainingReviewsButtonProps) {
      super(props);
      autoBind(this);
   }

   loadMoreReviews(remainingReviews: number, sortMetric: SortMetric, dashboardFilter: DashboardFilter, numberOfReviews: number) {
      this.setState({isLoadingData: true});
      this.loadReviewsCancelHelper = new AxiosCancelTokenHelper();

      ReviewService.loadReviews(sortMetric, numberOfReviews, remainingReviews, dashboardFilter, this.loadReviewsCancelHelper).then(() => {
         this.setState({isLoadingData: false});
      }).catch(e => {
         if (e.message === 'Network Error') {
            this.setState({
               isLoadingData: false,
               errorMessaging: {
                  title: Strings.errors.noNetworkConnection,
                  detail: Strings.errors.failedLoadDashboard
               }
            });
         } else if (!this.loadReviewsCancelHelper.isCancelled) {
            this.setState({
               isLoadingData: false,
               errorMessaging: {
                  title: Strings.errors.serverError,
                  detail: Strings.errors.serverErrorDetail,
                  statusCode: Constants.statusCodes.serverError
               }
            });
         }
      });
   }

   render() {
      const {themeName, totalReviewsCount, reviews, sortMetric, dashboardFilter} = this.props;
      const remainingReviews = totalReviewsCount - reviews.length;
      const userId = Store.getState().currentUserId;

      return (
         <>
            <div className="load-remaining-reviews" id="load-remaining-reviews-button-id">
               <ControlButton
                  label={Strings.labels.remainingReviewsButtonText}
                  themeName={themeName}
                  title={'Load Remaining Reviews'}
                  testId="load-remaining-reviews-button"
                  onClick={() => {
                     this.loadMoreReviews(remainingReviews, sortMetric, dashboardFilter, reviews.length);
                     GoogleAnalyticsService.trackLoadMoreReviewsButtonClicks(userId);
                  }}
                  disabled={this.state.isLoadingData}
               />
            </div>
         </>
      );
   }
}

export interface LoadRemainingReviewsButtonProps extends Themeable {
   reviews: ReviewModel[];
   totalReviewsCount: number;
   sortMetric: SortMetric;
   dashboardFilter: DashboardFilter;
}

interface LoadRemainingReviewsButtonState {
   errorMessaging: ErrorMessageModel;
   isLoadingData: boolean;
}